export { default } from './ContentArea';
